import React from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import LinearProgress from 'material-ui/LinearProgress';
import {isSignedIn} from '../reducer';
import {getResponse} from '../reducer/response';
import {fetchResponse} from '../actions/responses';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';
import CircularProgress from 'material-ui/CircularProgress';
import TosDialog from '../components/TosDialog';
import { signOut, acceptTos } from '../actions/auth';
import ReactGA from 'react-ga';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = { error: null };
    ReactGA.initialize('UA-163834956-1');
  }

  componentDidMount = () => {
    //reload if navigating using the back button. This reloads the state from teh database instead of the browser cache if the user has left the Tool and then hit back to return
    if(window.performance.navigation.type === 2){
       window.location.reload(true);
    }
    if (this.props.responseID && !this.props.response) {
      this.props.fetchResponse(this.props.responseID);
    }
  }

  render() {
    let {responseID, response, hasLoadedQDD, isSignedIn, authError, isPostingAnswer, tosSigned} = this.props;
    let loading = !hasLoadedQDD || responseID && !response;
    let loadingText = "Retrieving questions definitions...";
    if (hasLoadedQDD && !response) {
      loadingText = "Retrieving fishery information..."
    }
    return (
      <div>
        <Dialog
          title="Loading FishPath"
          modal={true}
          open={!!loading}
        >
          {loadingText}
          <br />
          <br />
          <LinearProgress mode="indeterminate" />
        </Dialog>
        { loading ? null : this.props.children }
        <Dialog
          open={!loading && !isSignedIn && window.location.pathname !== "/Questionnaire" && !/questionnaire\/results/.test(window.location.pathname)}
          title="You are signed out"
          actions={[
            <RaisedButton label="Okay" primary={true} onClick={() => window.location = '/Questionnaire'} />
          ]}
        >
          <div style={{color: 'red'}}>{authError}</div>
          <div>Please login and you can resume your session.</div>
        </Dialog>
        <Snackbar
          style={{
            right: "-40px",
            position: 'absolute',
            transform: 'translate(0%, 0px)',
            left: 'auto !important'
          }}
          bodyStyle={{
            backgroundColor: 'transparent'
          }}
          contentStyle={{
            textAlign: 'center',
            color: 'black'
          }}
          open={!!isPostingAnswer}
          message={<span style={{position: 'relative'}}>Saving answer <CircularProgress style={{position: 'absolute', top: -8, right: -40}} size={30} thickness={2} color="black" /></span>}
        />
        { isSignedIn && !tosSigned && <TosDialog open={true} onAccept={() => this.props.acceptTos()} onReject={() => this.props.logout()} />}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    hasLoadedQDD: state.sync.hasLoadedQDD,
    isSignedIn: isSignedIn(state),
    authError: state.auth.error,
    responseID: state.responses.responseID,
    response: getResponse(state),
    isSyncing: state.sync.isSyncing,
    isPostingAnswer: state.sync.isPostingAnswer,
    tosSigned: state.auth.tos === 'signed'
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchResponse: (id) => dispatch(fetchResponse(id)),
    logout: () => dispatch(signOut()),
    acceptTos: () => dispatch(acceptTos())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
